/**
 * Font family selection, environment-overridable.
 *
 * Selects WHICH already-registered font family (see src/utils/fonts.ts) to
 * use for Latin/primary text and Arabic/RTL text — not a new font-loading
 * mechanism. Defaults to Tajawal for both Latin and Arabic (it natively
 * supports both scripts). To switch fonts app-wide: register the new font
 * files in fonts.ts (both the native Font.loadAsync map and the web
 * WEB_FONTS array), then point these env vars at the new family key.
 */
import Constants from 'expo-constants';
import { fonts } from '../utils/fonts';

export interface FontConfig {
  primaryFamily: keyof typeof fonts;
  arabicFamily: keyof typeof fonts;
}

export const getFontConfig = (): FontConfig => {
  const appConfig = Constants.expoConfig?.extra;

  const primaryFamily =
    (appConfig?.fontFamilyPrimary || process.env.EXPO_PUBLIC_FONT_FAMILY_PRIMARY || 'tajawal') as keyof typeof fonts;
  const arabicFamily =
    (appConfig?.fontFamilyArabic || process.env.EXPO_PUBLIC_FONT_FAMILY_ARABIC || 'tajawal') as keyof typeof fonts;

  return {
    primaryFamily: fonts[primaryFamily] ? primaryFamily : 'tajawal',
    arabicFamily: fonts[arabicFamily] ? arabicFamily : 'tajawal',
  };
};
